/**
 * Nội dung tĩnh của trang /tai-app (landing cho người MỚI đến từ link giới thiệu).
 * Tách riêng để component chỉ lo phần hiển thị — số liệu ở đây phải là thông tin THẬT
 * đang áp dụng (mức hoàn tiền, hạn mức rút, thể lệ giới thiệu), không hứa thưởng ảo.
 */
import { faGift, faBolt, faBell, faTags, faWallet, faLink } from "@fortawesome/free-solid-svg-icons";

/** Sàn đang liên kết — logo lấy từ /public/img/brand-logo. */
export const MERCHANTS = [
    { name: "Shopee", logo: "/img/brand-logo/logo-shopee-200.png" },
    { name: "Lazada", logo: "/img/brand-logo/logo-lazada-200.png" },
    { name: "TikTok Shop", logo: "/img/brand-logo/logo-tiktok-shop-200.png" },
    { name: "ShopeeFood", logo: "/img/brand-logo/logo-shopeefood-200.png" },
];

/** 3 bước từ lúc tải app tới lúc tiền về tài khoản ngân hàng. */
export const STEPS = [
    {
        title: "Tải app & đăng ký",
        desc: "Đăng ký bằng email, miễn phí hoàn toàn. Có mã giới thiệu thì nhập ở bước đăng ký (bổ sung được trong 7 ngày đầu).",
    },
    {
        title: "Mua sắm qua app",
        desc: "Tìm sản phẩm ngay trong app, hoặc dán link sản phẩm bạn đang xem để lấy link hoàn tiền rồi bấm mua như bình thường.",
    },
    {
        title: "Nhận tiền & rút về ngân hàng",
        desc: "Đơn hiện trong mục Đơn hàng, tiền hoàn vào ví khi sàn duyệt đơn. Rút về ngân hàng từ 10.000đ, xác thực OTP qua email.",
    },
];

/** Lợi ích thật của app (không phải khuyến mãi có thời hạn). */
export const PERKS = [
    { icon: faGift, color: "text-rose-500", bg: "bg-rose-50", title: "x2 hoàn tiền", desc: "Mua qua App nhận gấp đôi hoàn tiền trong các đợt ưu đãi." },
    { icon: faBolt, color: "text-amber-500", bg: "bg-amber-50", title: "Voucher độc quyền", desc: "Săn voucher 0Đ khung giờ vàng, nhiều mã chỉ có trên App." },
    { icon: faTags, color: "text-emerald-500", bg: "bg-emerald-50", title: "Theo dõi giá", desc: "Lưu sản phẩm, giá giảm là App báo ngay để mua đúng đáy." },
    { icon: faLink, color: "text-violet-500", bg: "bg-violet-50", title: "Đổi link hoàn tiền", desc: "Dán link Shopee/Lazada/TikTok, App đổi thành link có hoàn tiền." },
    { icon: faBell, color: "text-blue-500", bg: "bg-blue-50", title: "Theo dõi đơn dễ dàng", desc: "Quản lý hoàn tiền, rút tiền & nhận thông báo ngay trên điện thoại." },
    { icon: faWallet, color: "text-sky-500", bg: "bg-sky-50", title: "Rút về ngân hàng", desc: "Rút từ 10.000đ, chuyển khoản về tài khoản ngân hàng của bạn." },
];

/** Câu hỏi người mới hay hỏi nhất — trả lời đúng chính sách đang chạy. */
export const FAQS = [
    {
        q: "Longhousee lấy tiền ở đâu để hoàn cho tôi?",
        a: "Longhousee là đối tác tiếp thị liên kết của Shopee, Lazada, TikTok Shop, ShopeeFood. Khi bạn mua qua App, sàn trả hoa hồng cho Longhousee và chúng tôi chia lại phần lớn khoản đó cho bạn.",
    },
    {
        q: "Dùng app có mất phí không?",
        a: "Không. Tải app, đăng ký và nhận hoàn tiền đều miễn phí. Giá sản phẩm trên sàn cũng không đổi khi mua qua link của Longhousee.",
    },
    {
        q: "Bao lâu thì nhận được tiền hoàn?",
        a: "Đơn thường được ghi nhận trong app sau vài giờ. Tiền vào ví khi sàn duyệt đơn (sau khi đơn hoàn tất và hết hạn đổi trả), thường 1-2 tháng tuỳ sàn.",
    },
    {
        q: "Rút tiền như thế nào?",
        a: "Vào mục Rút tiền, nhập số tiền và tài khoản ngân hàng, xác thực OTP gửi về email. Số dư rút tối thiểu là 10.000đ.",
    },
    {
        q: "Nhập mã giới thiệu tôi có bị mất gì không?",
        a: "Không. Mã giới thiệu chỉ giúp người mời bạn nhận thêm hoa hồng từ hệ thống — tiền hoàn của bạn vẫn giữ nguyên 100%.",
    },
    {
        q: "Tôi cũng mời được bạn bè chứ?",
        a: "Được. Khi tài khoản của bạn có từ 5 đơn được duyệt hoàn tiền, mục Giới thiệu sẽ mở link mời riêng: bạn nhận 10% (Shopee) hoặc 5% (Lazada, TikTok Shop) trên tiền hoàn của người được mời, trong 3 tháng đầu.",
    },
];
